import { api } from '@api'
import { useQuery } from '@tanstack/react-query'

export type ProfessionSector = {
  id: string
  name: string
}

const fetchProfessionSectors = async (): Promise<ProfessionSector[]> => {
  const { data } = await api.get<ProfessionSector[]>('/profession-sectors')
  return data
}

export const useGetProfessionSectors = () => {
  return useQuery<ProfessionSector[]>({
    queryKey: ['profession-sectors'],
    queryFn: fetchProfessionSectors,
  })
}

